import { useTranslations } from 'next-intl';

const RewindTenSecondsIcon = () => {
	const t = useTranslations('audio');
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="30"
			height="30"
			viewBox="0 0 30 30"
		>
			<title>{t('skipBackward')}</title>
			<path d="M 15 3 C 11.946149 3 9.1595062 4.1553732 7.0390625 6.0390625 L 5 4 L 5 10 L 11 10 L 8.4550781 7.4550781 C 10.209519 5.9310235 12.488026 5 15 5 C 20.534534 5 25 9.4654664 25 15 C 25 20.534534 20.534534 25 15 25 C 9.4654664 25 5 20.534534 5 15 A 1.0001 1.0001 0 1 0 3 15 C 3 21.615466 8.3845336 27 15 27 C 21.615466 27 27 21.615466 27 15 C 27 8.3845336 21.615466 3 15 3 z M 17.6875 11.349609 C 15.8715 11.349609 14.728516 12.710922 14.728516 15.044922 C 14.728516 17.378922 15.8555 18.774391 17.6875 18.775391 C 19.5135 18.775391 20.646484 17.374781 20.646484 15.050781 C 20.646484 12.706781 19.4995 11.349609 17.6875 11.349609 z M 11.134766 11.539062 L 9.34375 12.759766 L 9.34375 14.302734 L 11.042969 13.154297 L 11.134766 13.154297 L 11.134766 18.585938 L 12.927734 18.585938 L 12.927734 11.539062 L 11.134766 11.539062 z M 17.6875 12.726562 C 18.3715 12.726563 18.830078 13.496922 18.830078 15.044922 C 18.830078 16.602922 18.3715 17.398438 17.6875 17.398438 C 17.0035 17.398438 16.548828 16.602922 16.548828 15.044922 C 16.548828 13.496922 17.0035 12.726562 17.6875 12.726562 z"></path>
		</svg>
	);
};

export default RewindTenSecondsIcon;
